"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var banner_mini_jpg_1 = __importDefault(require("images/banners/company_recruitment/banner_mini.jpg"));
var AfterSearchContentModalForBusiness = function (props) {
    var _a = react_1.default.useState(true), open = _a[0], setIsOpen = _a[1];
    return (react_1.default.createElement(react_responsive_modal_1.default, { open: open, onClose: function () { return setIsOpen(false); }, classNames: { modal: 'blogShow-AfterSearchContentModalForBusiness_Wrapper' } },
        react_1.default.createElement("a", { href: props.url, className: "blogShow-AfterSearchContentModalForBusiness_Link" },
            react_1.default.createElement("img", { src: banner_mini_jpg_1.default, alt: "banner_mini.jpg", className: "blogShow-AfterSearchContentModalForBusiness_Image lazyload" }))));
};
exports.default = AfterSearchContentModalForBusiness;
